<template>
    <div>
        <div class="filter-header d-flex justify-content-end">
            <button class="btn btn-purple align-self-start" @click="togglePanel"><i class="fas fa-filter"></i></button>
            <slot name="buttons"></slot>
        </div>
        <div class="d-flex">
            <applied-filters
              :items="appliedLabels"
              @filter-remove="onFilterRemove"
            ></applied-filters>
        </div>
        <el-collapse-transition>
            <div v-show="isPanelVisible">
                <div class="row mt-2">
                    <component
                        v-for="item in list"
                        :key="item.name"
                        :is="item.component"
                        :name="item.name"
                        :values="values"
                        :pending-values="pending"
                        :data="item.data"
                        :class="item.classes"
                        @change="onChange"
                        @labels-changed="onLabelsChanged"
                    ></component>
                </div>
                <button class="btn btn-default" @click="apply">Apply</button>
                <button class="btn btn-default" @click="hide">Hide</button>
                <button class="btn btn-default" @click="reset">Reset</button>
            </div>
        </el-collapse-transition>
    </div>
</template>

<script>
    import FilterLabels from "./labels";

    export default {
        props: {
            values: {
                type: Object,
                default: () => {
                },
            },
            list: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                isPanelVisible: false,
                pending: {},
                labels: {},
            };
        },

        computed: {
            appliedLabels() {
                return _.flatten(_.values(this.labels));
            },
        },

        watch: {
            values: {
                handler: function (values) {
                    this.pending = _.assign({}, values);
                },
                immediate: true,
            }
        },

        methods: {
            /**
             * @return {undefined}
             */
            togglePanel() {
                this.isPanelVisible = !this.isPanelVisible;
            },

            /**
             * @return {undefined}
             */
            hide() {
                this.isPanelVisible = false;
            },

            /**
             * @return {undefined}
             */
            apply() {
                this.hide();
                this.$emit('apply', this.pending);
            },

            /**
             * @return {undefined}
             */
            reset() {
                this.$emit('apply', {});
            },

            /**
             * @param {Object} payload
             */
            onChange({name, value}) {
                if (_.isNull(value)) {
                    this.pending = _.assign({}, _.omit(this.pending, name));
                } else {
                    this.pending = _.assign({}, this.pending, {[name]: value});
                }
            },

            /**
             * @param {Object} value
             */
            onLabelsChanged({name, labels}) {
                this.labels = _.assign({}, this.labels, {[name]: labels});
            },

            /**
             * @param {Object} value
             */
            onFilterRemove({name, index}) {
                const filters = this.removeFilterValue(name, index);
                this.$emit('apply', filters);
            },

            /**
             * @param {String} name
             * @param {Number|null} index
             */
            removeFilterValue(name, index) {
                if (_.isNull(index) || _.size(this.values[name]) <= 1) {
                    return _.assign({}, _.omit(this.values, name));
                }

                const value = [...this.values[name]];
                value.splice(index, 1);

                return _.assign({}, this.values, {[name]: value});
            },
        },

        components: {
            AppliedFilters: FilterLabels,
        }
    }
</script>
